/**
 * SubmissionStatusBadge — the status chip for one Offertanfrage (P2 Placement Slice 8, Tab 3b) plus
 * a second «Frist abgelaufen» warning badge when the Frist has lapsed (derived flag).
 */

import { Badge } from '../../components/ui/Badge';
import { SUBMISSION_STATUS, SUBMISSION_STATUS_LABELS, SUBMISSION_FRIST_ABGELAUFEN_LABEL } from '@brokly/shared';
import type { SubmissionStatus } from '@brokly/shared';

type BadgeVariant = 'neutral' | 'outline' | 'success' | 'warning' | 'danger' | 'info';

const VARIANT_BY_STATUS: Record<SubmissionStatus, BadgeVariant> = {
  [SUBMISSION_STATUS.NEU]: 'neutral',
  [SUBMISSION_STATUS.VERSANDT]: 'info',
  [SUBMISSION_STATUS.ERINNERT]: 'warning',
  [SUBMISSION_STATUS.EINGEGANGEN]: 'success',
  [SUBMISSION_STATUS.NICHT_OFFERIERT]: 'danger',
  [SUBMISSION_STATUS.INAKTIV]: 'outline',
};

export function SubmissionStatusBadge({
  status,
  fristAbgelaufen,
}: {
  status: SubmissionStatus;
  fristAbgelaufen: boolean;
}) {
  const inaktiv = status === SUBMISSION_STATUS.INAKTIV;
  return (
    <span className="inline-flex items-center gap-1" data-testid="submission-status-badge">
      <Badge variant={VARIANT_BY_STATUS[status]}>
        <span className={inaktiv ? 'line-through' : undefined}>{SUBMISSION_STATUS_LABELS[status]}</span>
      </Badge>
      {fristAbgelaufen && <Badge variant="warning">{SUBMISSION_FRIST_ABGELAUFEN_LABEL}</Badge>}
    </span>
  );
}
